import React , {useEffect} from 'react';
import { Helmet } from 'react-helmet';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Center_Performance_2.css";
import { Link } from 'react-router-dom';



const MIN_SPEED = 1.5;
const MAX_SPEED = 2.5;

function randomNumber(min, max) {
  return Math.random() * (max - min) + min;
}

class Blob {
  constructor(el) {
    this.el = el;
    const boundingRect = this.el.getBoundingClientRect();
    this.size = boundingRect.width;
    this.initialX = randomNumber(0, window.innerWidth - this.size);
    this.initialY = randomNumber(0, window.innerHeight - this.size);
    this.el.style.top = `${this.initialY}px`;
    this.el.style.left = `${this.initialX}px`;
    this.vx = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.vy = randomNumber(MIN_SPEED, MAX_SPEED) * (Math.random() > 0.5 ? 1 : -1);
    this.x = this.initialX;
    this.y = this.initialY;
  }

  update() {
    this.x += this.vx;
    this.y += this.vy;
    if (this.x >= window.innerWidth - this.size) {
      this.x = window.innerWidth - this.size;
      this.vx *= -1;
    }
    if (this.y >= window.innerHeight - this.size) {
      this.y = window.innerHeight - this.size;
      this.vy *= -1;
    }
    if (this.x <= 0) {
      this.x = 0;
      this.vx *= -1;
    }
    if (this.y <= 0) {
      this.y = 0;
      this.vy *= -1;
    }
  }

  move() {
    this.el.style.transform = `translate(${this.x - this.initialX}px, ${this.y - this.initialY}px)`;
  }
}

const CenterStage2 = () => {

  useEffect(() => {
    const initBlobs = () => {
      const blobEls = document.querySelectorAll('.bouncing-blob');
      const blobs = Array.from(blobEls).map((blobEl) => new Blob(blobEl));

      function update() {
        requestAnimationFrame(update);
        blobs.forEach((blob) => {
          blob.update();
          blob.move();
        });
      }

      requestAnimationFrame(update);
    };

    initBlobs();

    // Cleanup function if needed
    // return () => { cleanup };
  }, []);
  return (
    <div className="schedule-container">
            <div className="bouncing-blobs-container">
        <div className="bouncing-blobs-glass"></div>
        <div className="bouncing-blobs">
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--blue"></div>
          <div className="bouncing-blob bouncing-blob--white"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--purple"></div>
          <div className="bouncing-blob bouncing-blob--pink"></div>
        </div>
      </div>
      <div className="hero"></div>

      <div className="base-box">
          {/*시각*/}
          <div>
            <Helmet>
             <link rel="preconnect" href="https://fonts.googleapis.com" />
             <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="true" />
             <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Jua&display=swap" rel="stylesheet" />
            </Helmet>
           <div className="time-block_Oclock">18:00</div>
           <div className="time-block">18:10</div>
           <div className="time-block">18:20</div>
           <div className="time-block">18:30</div>
           <div className="time-block">18:40</div>
           <div className="time-block">18:50</div>
           <div className="time-block_Oclock">19:00</div>           
           <div className="time-block">19:10</div>
           <div className="time-block">19:20</div>
           <div className="time-block">19:30</div>
           <div className="time-block">19:40</div>
           <div className="time-block">19:50</div>
           <div className="time-block_Oclock">20:00</div>
           <div className="time-block">20:10</div>
           <div className="time-block">20:20</div>
           <div className="time-block">20:30</div>
           <div className="time-block">20:40</div>
           <div className="time-block">20:50</div>
           <div className="time-block_Oclock">21:00</div>
           <div className="time-block">21:10</div>
           <div className="time-block">21:20</div>
           <div className="time-block">21:30</div>
           <div className="time-block">21:40</div>
           <div className="time-block">21:50</div>
           <div className="time-block_Oclock">22:00</div>
          </div>
          {/*공연순서*/}
          <div className='posi2'>
           <Helmet>
             <link rel="preconnect" href="https://fonts.googleapis.com" />
             <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
             <link href="https://fonts.googleapis.com/css2?family=Jua&display=swap" rel="stylesheet" />
           </Helmet>
           <div className="list-box_opening">오프닝</div>
           <div className="list-box_15m_purple">태권도부</div>
           <div className="list-box_10m_white">전부호</div>
           <div className="list-box_10m_purple">김지온</div>
           <div className="list-box_10m_white">경력직</div>
           <div className="list-box_10m_purple">가현회</div>
           <div className="list-box_15m_white">기가히츠</div>
           <div className="list-box_10m_purple">TENZ</div>
           <div className="list-box_15m_white">화랑</div>
           <div className="list-box_spacer"></div>{/*간격조정*/}
           <div className="list-box_15m_purple">CDZ</div>
           <div className="list-box_event">가대가요제 및 경품행사(불꽃놀이)</div>
           <div className="list-box_singer">STAYC</div>
           <div className="list-box_singer">다이나믹듀오</div>
          </div>
          {/*시간선*/}
     

        </div>
      <div>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="true" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Jua&display=swap" rel="stylesheet" />
      </Helmet>
      <Link to="/centerstage1">
          <button className="nav-button-white">DAY 1</button>
        </Link>
        <Link to="/performance">
          <button className="nav-button-white-2">BACK</button>
        </Link>
      </div>
    </div>
    
  );
};

export default CenterStage2;
